import ApiService from './api.service'

export default {
  // The question and nothing else. WHICH HmRag pipeline answers is the API's decision, not
  // the browser's (owner, 2026-09-23): the WebQuote API always asks for the decision channel
  // -- `HmRagChatRequest.DecisionChannel`, asserted in HmRagChannelTest.cs. DeepThink, which
  // used to ride along here, is gone with the choice it offered.
  chat(question) {
    return ApiService.post('/api/hmrag/chat', { question })
  },

  rateAnswer(queryId, stars, comment) {
    return ApiService.post(`/api/hmrag/chat/${encodeURIComponent(queryId)}/rating`, {
      stars,
      comment: comment || null
    })
  },

  getWikiIndex() {
    return ApiService.get('/api/hmrag/wiki')
  },

  getWikiPage(slug) {
    return ApiService.get(`/api/hmrag/wiki/${encodeURIComponent(slug)}`)
  },

  // Where an image reference resolves to. Kept here so the sanitizer and the fetch agree on one
  // url rather than each building its own.
  wikiImageUrl(slug, reference) {
    return `/api/hmrag/wiki/${encodeURIComponent(slug)}/image?ref=${encodeURIComponent(reference)}`
  },

  // Fetched through axios, not by the browser: an <img src> carries no bearer token, so the API
  // would answer 401 and the reader would get a broken-image icon.
  getWikiImage(url) {
    return ApiService.customRequest({ method: 'GET', url, responseType: 'blob' })
  },

  getWikiEvidence(slug, claimId, citationNumber) {
    return ApiService.get(
      `/api/hmrag/wiki/${encodeURIComponent(slug)}/evidence` +
      `?claimId=${encodeURIComponent(claimId)}&citationNumber=${encodeURIComponent(citationNumber)}`
    )
  }
}
